import React, { useRef } from "react";
import { func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { parseUrl } from "query-string";

import TopArrowContainer from "../../atoms/TopArrowContainer";
import WithSSO from "../../with-sso";
import Icon from "../../icons";

import { useOuterClickNotifier } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./loginRegister.m.css";

const LoginRegister = ({ closeView, authHost, publisherAttributes = {}, currentPath, sketchesHost }) => {
  const loginRegisterRef = useRef(null);

  const params = parseUrl(currentPath);
  let redirectUrl;
  const callbackUrl = get(params, ["query", "callback-url"], global.location.origin);

  const getRedirectUrl = defaultRedirectUrl => {
    redirectUrl = get(params, ["query", "redirect-url"], defaultRedirectUrl);
    return redirectUrl;
  };

  if (params.url.includes("sign-in-page") || params.url.includes("sign-up-page")) {
    getRedirectUrl(sketchesHost);
  } else {
    params.url.includes("verify-email") ? getRedirectUrl(sketchesHost) : getRedirectUrl(global.location.href);
  }

  useOuterClickNotifier(closeView, loginRegisterRef);

  return (
    <div styleName="top-arrow-container-wrapper" ref={loginRegisterRef}>
      <TopArrowContainer className="top-arrow-container" closeView={closeView}>
        <WithSSO
          ssoHost={authHost}
          signInPath="/sign-in-page"
          signUpPath="/sign-up-page"
          redirectUrl={redirectUrl}
          callbackUrl={callbackUrl}
        >
          {({ signInHref, signUpHref }) => (
            <div styleName="login-register-btn">
              <a title="Login" className="login-register-link" styleName="login-register-link" href={signInHref}>
                {publisherAttributes && publisherAttributes.lang === "bn" ? "লগইন" : "Login"}
              </a>
              <span styleName="line-separater" />
              <a title="Register" className="login-register-link" styleName="login-register-link" href={signUpHref}>
                {publisherAttributes && publisherAttributes.lang === "bn" ? "রেজিস্টার" : "Register"}
              </a>
            </div>
          )}
        </WithSSO>

        <div styleName="summary-wrapper">
          <p>{staticTexts(publisherAttributes.lang).loginorRegister}</p>
          <div styleName="story-summary">
            <span styleName="icon">
              <Icon type="bookmark-outline" className="bookmark-outline" />
            </span>
            {staticTexts(publisherAttributes.lang).saveToRead}
          </div>
          <div styleName="story-summary">
            <span styleName="icon">
              <Icon type="comments-outline" className="comments-outline" />
            </span>
            {staticTexts(publisherAttributes.lang).commentAndReply}
          </div>
          <div styleName="story-summary">
            <span styleName="icon">
              <Icon type="bell" className="bell" />
            </span>
            {staticTexts(publisherAttributes.lang).breakingNewsAlerts}
          </div>
        </div>
      </TopArrowContainer>
    </div>
  );
};

LoginRegister.propTypes = {
  closeView: func,
  publisherAttributes: object,
  authHost: string,
  currentPath: string,
  sketchesHost: string
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com")
  };
};

export default connect(mapStateToProps, null)(LoginRegister);
